module.exports = "<router-outlet></router-outlet>\r\n<ng2-toasty [position]=\"position\"></ng2-toasty>\r\n<!-- <app-testcomponent></app-testcomponent> -->\r\n<!-- <a routerLink=\"/test\">test</a> -->"


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main